/* Full Feast — keeps the cart progress bar honest after every cart change.
   Refetches /cart.js rather than trusting a locally added line price, because
   the total we care about is the discounted one Shopify calculates. */
(function () {
  var money = function (pennies) {
    return '£' + (pennies / 100).toFixed(2).replace(/\.00$/, '');
  };

  function paint(cart) {
    document.querySelectorAll('[data-ff-progress]').forEach(function (el) {
      var threshold = parseInt(el.dataset.threshold, 10) || 0;
      var total = cart.total_price;
      var remaining = threshold - total;
      var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;

      el.classList.toggle('ff-progress--empty', cart.item_count === 0);

      var fill = el.querySelector('[data-ff-progress-fill]');
      if (fill) fill.style.width = pct + '%';

      var track = el.querySelector('.ff-progress__track');
      if (track) track.setAttribute('aria-valuenow', Math.round(pct));

      var tier2 = el.querySelector('[data-ff-progress-tier2]');
      if (tier2) tier2.classList.toggle('is-met', remaining <= 0);

      /* Only name a discount Shopify has actually applied. */
      var disc = (cart.cart_level_discount_applications || [])[0];
      var lead = disc ? (disc.title + ' applied. ') : '';

      var tier1 = el.querySelector('.ff-progress__tier');
      if (tier1) tier1.classList.toggle('is-met', !!disc);

      var msg = el.querySelector('[data-ff-progress-message]');
      if (msg) {
        msg.innerHTML = remaining > 0
          ? lead + 'Spend <strong>' + money(remaining) + '</strong> more for free UK delivery.'
          : lead + '<strong>Free UK delivery unlocked.</strong>';
      }
      el.dataset.total = total;
    });
  }

  function refresh() {
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js',
          { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () { /* leave the server-rendered state alone */ });
  }

  /* Catch every route that mutates the cart, whatever the theme or an app uses. */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var href = typeof url === 'string' ? url : (url && url.url) || '';
    return origFetch.apply(this, arguments).then(function (res) {
      if (/\/cart\/(add|change|update|clear)/.test(href)) setTimeout(refresh, 60);
      return res;
    });
  };
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('DOMContentLoaded', refresh);
})();
